// src/pages/uvalue.jsx
import Head from 'next/head';
import dynamic from 'next/dynamic';
import EnergieberegnerLayout from '../components/EnergieberegnerLayout';
import RequireProject from '../components/RequireProject';
import cardCss from '../styles/calculatorCard.module.css';

const UValueTab = dynamic(
    () => import('../components/calculators/uvalue/UValueTab'),
    { ssr: false }
);

export default function UValuePage() {
    return (
        <>
            <Head>
                <title>Digitaltbyggeri - Energieberegner</title>
            </Head>

            <EnergieberegnerLayout title="U-værdi-beregner">
                <RequireProject>
                    <section className={cardCss.card}>
                        <h2 className={cardCss.calcHeading}>U-værdi-beregner</h2>
                        <p className="introText">
                        Beregn U-værdien for én eller flere konstruktioner. Resultaterne kan
                        efter behov gemmes i et lille <strong>konstruktionsbibliotek</strong>, så du
                        nemt kan genbruge dem i andre projekter eller i fanerne{' '}
                        <strong>Varmetabsramme</strong> og <strong>Årlig besparelse</strong>. Værktøjet
                        understøtter både homogene og inhomogene lag samt tillæg A.2 og A.3
                        fra DS 418.
                        </p>
                        <UValueTab />
                    </section>
                </RequireProject>
            </EnergieberegnerLayout>
        </>
    );
}